import moment from "moment"
import React, { useEffect, useRef, useState } from "react"
import { ActivityIndicator, Image, View } from "react-native"
import { Icon } from "react-native-elements"
import { connect, useDispatch, useSelector } from "react-redux"
import Colors from "../../../constants/Colorsv2"
import { FINALIZED_STATUSES } from "../../../Datav2/events"
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { event_activateEvent, event_getEventByEventId } from "../../../store/actionsv1/events"
import { market_getLatestTradesByEventId, market_getOrderStatsByEvent, market_setDraftOrder } from "../../../store/actionsv1/markets"
import { PublicPlayerProps } from "../../../store/types/auth_svc"
import { EventOrderStatProps, MarketProps, TradeProps } from "../../../store/types/mk_svc"
import { EventProps, LeagueProps } from "../../../store/types/sr_svc"
import { CompetitionMatchMarketProps, PlayerPickProps } from "../../../store/types/tp_svc"
import { useIsInViewport } from "../../../utilsv1/helpers"
import Switch from "../../Social/components/Switch"
import { market_getMarketsFromSupportedMarkets } from "../helpers/markets"
import { trade_getOrderFromTrade } from "../helpers/trades"
import MarketCard from "./MarketCard"
import NonPrimaryMarketCard from "./NonPrimaryMarketCard"

type EventMarketCardProps = {
    navigation:any,
    event_id:string,
    trades_override?:TradeProps[];
    prevent_event_load?:boolean,
    market_override?:MarketProps,
    hide_event_header?:boolean
    hide_market_headers?:boolean
    markets_override?:string[]
    hide_border?:boolean,
    hide_market_footers?:boolean
    picks?:PlayerPickProps[];
    add_to_comp_toggle?:boolean
    lock_markets?:boolean,
    source?:'market'|'competition_create'|'competition_play'
    onCompPick?: (trade:TradeProps) => void
    add_to_comp_value?: boolean,
    additional_competition_markets?:CompetitionMatchMarketProps[],
    onAddToComp?: (event:EventProps) => void,
    onShowAdditionalMarkets?: (event:EventProps) => void
}

const EventMarketCard = ({ 
    navigation, 
    event_id, 
    trades_override, 
    prevent_event_load, 
    markets_override,
    market_override, 
    hide_border,
    hide_event_header, 
    hide_market_headers, 
    hide_market_footers,
    source,
    lock_markets,
    add_to_comp_toggle,
    picks,
    onCompPick,
    add_to_comp_value,
    onAddToComp,
    additional_competition_markets,
    onShowAdditionalMarkets
}:EventMarketCardProps) => {
    const [ markets_loading, setMarketsLoading ] = useState(false);
    const [ event_loaded, setEventLoaded ] = useState(false);    
    const [ trades_loaded, setTradesLoaded ] = useState(false);
    const dispatch = useDispatch();
    const market_type = useSelector((state:any) =>  state.auth.market_type, (left, right) => left == right)
    const event:EventProps | undefined = useSelector((state:any) => state.event.events[event_id], (left, right) => {
        if(left.time_detail !== right.time_detail){ return false }
        if(left?.event_id != right?.event_id){ return false }
        if(left?.is_active != right?.is_active){return false}
        if(left?.supported_markets != right?.supported_markets){ return false }
        if(left?.last_update_datetime != right?.last_update_datetime){ return false }
        return true
    })

    //Settings
    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const league:LeagueProps|undefined = useSelector((state:any) => state.event.leagues.find((l:LeagueProps) => l.league_id == event?.league_id), (left, right) => left?.league_id == right?.league_id)

    let order_stats:EventOrderStatProps[] = useSelector((state:any) => state.market.order_stats[`team:${event_id}`], (left, right) => left == right);
    if(!order_stats){ order_stats = [] }
    if(market_override){
        order_stats = order_stats.filter(os => os.market_id == market_override.market_id)
    }
    const markets = useSelector((state:any) => state.market.markets, (left, right) => left.length === right.length) 
    let available_markets = market_getMarketsFromSupportedMarkets(event?.supported_markets??[], markets)
    available_markets = available_markets.filter(m => m.primary_market)
    if(markets_override){
        available_markets = available_markets.filter(am => markets_override.map(m => m.toString()).includes(am.market_id))
    }
    if(market_override){ available_markets = [market_override] }
    const event_ref = useRef()
    const isInViewport1 = useIsInViewport(event_ref)
    
    useEffect(() => {
        if(!event_loaded && isInViewport1){
            getEventDetailsFromServer(event_id)
        }
    },[isInViewport1])

    useEffect(() => {
        if(!event || trades_loaded){ return }
        if(event.is_active){ 
            getMarketDetailsFromServer(event_id);
            return;
        }
    },[event])

    const getEventDetailsFromServer = async(event_id:string) => {
        if(!event && !prevent_event_load){
            await dispatch(event_getEventByEventId(event_id))
        }
        setEventLoaded(true)
    }
    const getMarketDetailsFromServer = async(event_id:string) => {
        if(!prevent_event_load){
            await dispatch(market_getLatestTradesByEventId(event_id, 'team'))
            await dispatch(market_getOrderStatsByEvent(event_id, 'team'))
        }
        setTradesLoaded(true)
    }

    const handleActivate = async() => {
        if(!event || !player || player.role !== 'admin' || source !== 'market'){ return }
        if(event.status === 'closed'){ return }
        setMarketsLoading(true)
        await dispatch(event_activateEvent(event.event_id))
        setTimeout(async() => {
            await dispatch(market_getLatestTradesByEventId(event_id, 'team'))
            setMarketsLoading(false)
        }, 3000);
    }

    const handleSelectTrade = (trade:TradeProps) => {
        if(!event){ return }
        if(source === 'competition_create'){ return }
        if(source === 'competition_play'){
            if(!onCompPick){ return }
            return onCompPick(trade)
        }
        return dispatch(market_setDraftOrder(trade_getOrderFromTrade(trade)))
    }
   if(event_loaded && !event){ return <></> }

    return (
    <View ref={event_ref} style={{ ...styles.cardStyle, borderWidth: hide_border?0:1 }}>
        { !event_loaded ?
        <View style={{ height:150 }} />
        :
        <View>
            {(event?.event_sub_title || event?.info?.broadcast?.network) ?
            <View style={{ flexDirection:'row', alignItems:'center', padding:7, backgroundColor:Colors.shades.shade100, borderTopRightRadius:12, borderTopLeftRadius:12 }}>
                <View style={{ flex:1, marginRight:5 }}>
                {event?.last_play ?
                <Text size={12} color={Colors.brand.midnight} weight='regular'>{event.last_play}</Text>
                :event?.event_sub_title ?
                <Text weight='semibold' size={12} color={Colors.brand.midnight}>{event?.event_sub_title}</Text>
                :<></>}
                </View>
                {event?.info?.broadcast?.network ?
                <Text weight='semibold' size={12} color={Colors.brand.midnight} textAlign="right">{event.info.broadcast.network}</Text>
                :<></>}
            </View>
            :<></>}
            <View>
                <View nativeID="info" style={{ flexDirection:'row', padding:7 }}>
                    {!hide_event_header ?
                    <View nativeID="event_info" style={{ flex:1 }}>
                        {moment(event?.scheduled_datetime).isBefore(moment()) ?
                        <Text size={12} color={Colors.shades.black} weight='regular'>{player?.role === 'admin'?`${event?.event_id}`:''}{league?.league_name} - {event.time_detail}</Text>
                        :
                        <Text size={12} color={Colors.shades.black} weight='regular'>{player?.role === 'admin'?`${event?.event_id}`:''}{league?.league_name} - {moment(event?.scheduled_datetime).format('MM/DD @ hh:mm a')}</Text>
                        }
                    </View>
                    :<></>}
                    {!hide_market_headers ?
                    <View nativeID="market_info" style={{ flex:1, flexDirection:'row' }}>
                        {available_markets.map(m => {
                            return (
                                <Text key={m.market_id.toString()} style={{ flex:1 }} size={12} color={Colors.brand.midnight} textAlign='center'>{m.type.toUpperCase()}</Text>
                            )
                        })}
                    </View>
                    :<></>}
                </View>
                <View style={{flexDirection:'row', padding:7}}>
                    {market_override?.description_override ?
                    <View style={{ flex:1 }}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold'>{market_override.description}</Text>
                    </View>
                    :
                    <View style={{ flex:1 }}>
                        {market_override?.stat_label ?
                            <Text size={14} color={Colors.brand.midnight} weight='bold'>{market_override.description}</Text>
                        :<></>}
                        <View nativeID="event_away_info" style={{ flex:1, flexDirection:'row', marginRight:3, minHeight:35, alignItems:'center' }}>
                            <View style={{ flex:5/6 }}>
                                <View style={{ flexDirection:'row', alignItems:'flex-start' }}>
                                    {event?.away?.rank ?
                                    <Text style={{ marginRight:4 }} size={12} color={Colors.brand.cyan} weight='bold'>{event.away.rank} </Text>
                                    :<></>}
                                    {event?.away?.image?.url?
                                    <Image
                                        source={{ uri: event.away.image.url }}
                                        style={{ height:18, width:18, marginRight:5 }}
                                        resizeMode="cover"
                                    />
                                    :<></>}
                                    <Text size={12} color={Colors.shades.black} weight='semibold'>{event.away.market_name} {event.away.name}</Text>
                                </View>
                                {event?.away_sub_title ?
                                <Text size={12} color={Colors.brand.midnight} weight='regular'>{event?.away_sub_title}</Text>
                                :<></>}
                            </View>
                            <Text style={{ flex:1/6 }} size={12} color={Colors.shades.black} weight='semibold' textAlign="right">{event.away_team_score??0}</Text>
                        </View>
                        
                        <View nativeID="event_home_info" style={{ flex:1, flexDirection:'row', marginRight:3, minHeight:35, alignItems:'center'  }}>
                            <View style={{ flex:5/6 }}>
                                <View style={{ flexDirection:'row', alignItems:'flex-start' }}>
                                    {event?.home?.rank ?
                                    <Text style={{ marginRight:4 }} size={12} color={Colors.brand.cyan} weight='bold'>{event.home.rank}</Text>
                                    :<></>}
                                    {event?.home?.image?.url?
                                    <Image
                                        source={{ uri: event.home.image.url }}
                                        style={{ height:18, width:18, marginRight:5 }}
                                        resizeMode="cover"
                                    />
                                    :<></>}
                                    <Text size={12} color={Colors.shades.black} weight='semibold'>{event.home.market_name} {event.home.name}</Text>
                                </View>                            
                                {event?.home_sub_title ?
                                <Text size={12} color={Colors.shades.black} weight='regular'>{event?.home_sub_title}</Text>
                                :<></>}
                            </View>
                            <Text style={{ flex:1/6 }} size={12} color={Colors.shades.black} weight='semibold' textAlign="right">{event?.home_team_score??0}</Text>
                        </View>
                        
                    </View>
                    }
                    {trades_loaded && !lock_markets && !FINALIZED_STATUSES.includes(event?.status) && source === 'market' || (source === 'competition_create') || ((source === 'competition_play' && !lock_markets && trades_override && trades_override.length > 0) || (!markets_loading && source === 'market' && event?.is_active && !FINALIZED_STATUSES.includes(event?.status))) ?
                    <View nativeID="markets" style={{ flex:1, flexGrow:1, flexDirection:'row' }}>
                        {available_markets.map(m => {
                            if(market_override && market_override.market_id != m.market_id){ return }
                            let side_array:any = []
                            m.side_options.map(o => {
                                let side:any = { side: o.side }
                                if(o.id_source === 'team'){ side.side_id = event[o.side as keyof EventProps]?.team_id }
                                else { side.side_id = o.side }
                                side_array.push(side)
                            })
                            let pick = undefined
                            if(picks && picks.length > 0){
                                pick = picks.find(p => p.market_id == m.market_id)
                            }
                            return (
                                <View key={m.market_id.toString()} style={{flex:1}}>
                                    <MarketCard 
                                        align={market_override?.description_override ? 'horizontal': 'vertical'} 
                                        market={m}
                                        source={source}
                                        trades_override={trades_override}
                                        side_array={side_array}
                                        pick={pick}
                                        event_id={event.event_id} 
                                        event_type='team'
                                        onPress={(trade) => handleSelectTrade(trade)}
                                        />
                                </View>
                            )
                        })}
                    </View>
                    : markets_loading ? 
                    <View style={{ padding:10, justifyContent:'center', alignItems:'center' }}>
                        <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                    </View>
                    :
                    <TouchableOpacity style={{ flex:1, justifyContent:'center', alignItems:'center' }} onPress={() => handleActivate()}>
                        <Icon name='lock' type='feather' color={Colors.brand.midnight} size={28}/>
                        {player?.role === 'admin' && event?.status !== 'closed' && source === 'market' ? 
                        <Text size={12} color={Colors.brand.electric} style={{marginTop:5}}>UNLOCK</Text>
                        :<></>}
                    </TouchableOpacity>
                    }
                </View>
                {source === 'competition_create' && add_to_comp_toggle ?
                <View style={{ padding:7, flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:5, borderTopWidth:1, borderColor:Colors.shades.shade100}}>
                    <TouchableOpacity onPress={() => {
                        if(onShowAdditionalMarkets){ return onShowAdditionalMarkets(event) }
                    }}>
                        <View style={{ flexDirection:'row', alignItems:'center' }}>
                            <View style={{ height:24, width:24, marginRight:5, borderRadius:100, justifyContent:'center', alignItems:'center', backgroundColor:Colors.brand.electric }}>
                            {additional_competition_markets ?
                                <Text size={12} color={Colors.shades.white} weight='semibold'>{additional_competition_markets.length / 2}</Text>
                            :
                                <Icon name='plus' type='feather' color={Colors.shades.white} size={14} />
                            }
                            </View>
                            <Text size={14} weight='regular' color={Colors.brand.electric}>Additional Markets</Text>

                        </View>
                    </TouchableOpacity>
                    <View style={{ flexDirection:'row', alignItems:'center' }}>
                        <Text style={{ marginRight:5 }} size={14} color={Colors.brand.electric}>Add</Text>
                        <Switch value={add_to_comp_value} switch_type="on_off" onChange={() => {
                            if(onAddToComp){ return onAddToComp(event) }
                        }} />
                    </View>
                    
                </View>
                :
                <View style={{ backgroundColor:Colors.shades.shade100, borderBottomRightRadius:12, borderBottomLeftRadius:12}}>
                    {market_type === 'FOR_MONEY' && !hide_market_footers && available_markets.length > 0 && !FINALIZED_STATUSES.includes(event?.status) ?
                    <View>
                       <NonPrimaryMarketCard
                        event_type='team'
                        navigation={navigation}
                        event_id={event_id}
                        last_play={event?.last_play}
                        market_override={market_override?.market_id}
                        supported_markets={event?.supported_markets ?? []}
                        onMarketDetails={() => navigation.push('Market', { event_type: 'team', event_id:event?.event_id, market_id: available_markets[0]?.market_id })}
                        />
                    </View>
                    :<></>}
                </View>
            }
            </View>
            {league?.league_name == 'WWC' ?
                <View style={{ padding:8, borderBottomRightRadius:8, borderBottomLeftRadius:8, backgroundColor:Colors.utility.warning }}>
                    <Text weight='regular' color={Colors.shades.black} size={10}>Markets only applicable to regulation time.  See <TouchableOpacity onPress={() => window.open('https://www.bettoredge.com/general-rules', '_blank')}><Text size={10} color={Colors.brand.electric} weight='bold'>HERE</Text></TouchableOpacity> for rules</Text>
                </View>
                :<></>}
        </View>
        }
        {player?.role === 'admin' ?
        <TouchableOpacity style={{ position:'absolute', top:2, right:2, height:20, width:20, borderRadius:100, backgroundColor:Colors.brand.electric }} onPress={() => handleActivate()}>

        </TouchableOpacity>
        :<></>}
    </View>
    )
}

const styles = {
    cardStyle: { borderRadius: 12, borderWidth: 1, borderColor: Colors.shades.shade400 }
}

export default EventMarketCard




/*
 <MarketCardFooter 
                            open_order_count={open_order_count}
                            onStatPress={() => navigation.push('Market', { event_type: 'team', event_id:event?.event_id, market_id: available_markets[0]?.market_id })}
                            onMarketPress={() => navigation.push('Market', { event_type: 'team', event_id:event?.event_id, market_id: available_markets[0]?.market_id })}
                        />
*/